import { BOARD_CONDITIONS, getBoardConditionName } from './boardConditions';
import BoardTileLegend, {
  closeDisclosureOnEscape,
  closeOtherInlineDisclosure,
} from './BoardTileLegend';
import './BoardConditions.css';
import CoreboundIcon from './CoreboundIcon';

export const BoardConditionBadge = ({ condition }) => {
  const definition = BOARD_CONDITIONS[condition?.type];
  return (
    <span
      className="coreboundConditionBadge"
      style={{ '--condition-color': definition?.color || '#a9c6d4' }}
    >
      <CoreboundIcon name={condition?.type || 'stable'} />{' '}
      {getBoardConditionName(condition)}
    </span>
  );
};

const BoardConditionNotice = ({
  condition,
  compact = false,
  inline = false,
  shared = false,
  showLegend = true,
}) => {
  const definition = BOARD_CONDITIONS[condition?.type];
  if (!definition) return null;
  if (inline) {
    return (
      <div
        className="coreboundConditionControls"
        role="group"
        aria-label={`Board condition: ${getBoardConditionName(condition)}`}
      >
        {showLegend && <BoardTileLegend />}
        <details
          className="coreboundBoardCondition coreboundConditionInline"
          style={{ '--condition-color': definition.color }}
          onKeyDown={closeDisclosureOnEscape}
          onToggle={closeOtherInlineDisclosure}
        >
          <summary>
            <span className="coreboundConditionIcon" aria-hidden="true">
              <CoreboundIcon name={condition.type} />
            </span>
            <strong>{getBoardConditionName(condition)}</strong>
            <span className="coreboundConditionDisclosure" aria-hidden="true">
              ⌄
            </span>
          </summary>
          <div className="coreboundConditionDetails">
            <p>
              {definition.description} {definition.tip}
            </p>
            {shared && <small>This condition affects both boards.</small>}
          </div>
        </details>
      </div>
    );
  }
  return (
    <div
      className={`coreboundBoardCondition ${
        compact ? 'coreboundConditionFlight' : ''
      }`}
      style={{ '--condition-color': definition.color }}
      aria-label={`Board condition: ${getBoardConditionName(condition)}`}
    >
      <span className="coreboundConditionIcon" aria-hidden="true">
        <CoreboundIcon name={condition.type} />
      </span>
      <div className="coreboundConditionCopy">
        <strong>
          {getBoardConditionName(condition)}
          {shared && <small> · BOTH BOARDS</small>}
        </strong>
        {!compact && (
          <span>
            {definition.description} {definition.tip}
          </span>
        )}
      </div>
    </div>
  );
};

export default BoardConditionNotice;
